import React from "react";

interface ContentWrapperProps {
  unwrap?: boolean;
  className?: string;
}

export default function ContentWrapper({
  unwrap,
  children,
  className,
}: React.PropsWithChildren<ContentWrapperProps>) {
  let childElement = children;
  if (unwrap) {
    childElement = <div className="unwrap">{children}</div>;
  }
  return (
    <div className={"content-wrapper" + (className ? ` ${className}` : "")}>{childElement}</div>
  );
}
